function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import * as React from "react";

var General = function General(props) {
  var itemAsegurado = props.itemAsegurado,
      _onChange = props.onChange;
  return /*#__PURE__*/React.createElement("div", {
    className: "card-body cardBody"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-md-10"
  }, /*#__PURE__*/React.createElement("label", {
    className: "form-label"
  }, "Materia Asegurada"), /*#__PURE__*/React.createElement("textarea", {
    className: "form-control",
    rows: 6,
    value: (itemAsegurado === null || itemAsegurado === void 0 ? void 0 : itemAsegurado.materia_asegurada) || "",
    onChange: function onChange(event) {
      return _onChange && _onChange(_objectSpread(_objectSpread({}, itemAsegurado), {}, {
        materia_asegurada: event.target.value
      }));
    }
  })));
};

export default General;